"use client"

import { useAuth } from "@/lib/profile-context"
import { useRouter } from "next/navigation"
import { useEffect } from "react"

export default function HomePage() {
  const { user, loading } = useAuth()
  const router = useRouter()
  useEffect(() => {
    // Redirecionamento automático quando loading for false
    if (!loading) {
      if (user) {
        router.push("/inicio")
      } else {
        router.push("/login")
      }
    } else {
    }
  }, [user, loading, router])

  // Mostrar loading enquanto está verificando
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <div className="flex items-center space-x-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span>Verificando autenticação...</span>
          </div>
        </div>
      </div>
    )
  }

  // Esta parte só aparece se houver algum problema com o redirecionamento
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-xl font-bold mb-4">Erro de Redirecionamento</h1>
        <p className="mb-4">Estado: loading={loading ? 'true' : 'false'}, user={user ? 'logado' : 'não logado'}</p>
        <button 
          onClick={() => router.push("/login")}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Ir para Login Manualmente
        </button>
      </div>
    </div>
  )
}
